var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5477_3131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05291 8.49266H8.82564C8.64228 8.25214 8.53657 7.96145 8.52261 7.65933V7.05327C8.52261 7.05327 8.63337 6.7813 8.52261 6.14418L8.37109 5.68963V5.23509C8.37109 5.23509 8.39526 5.01721 8.59837 5.00781H8.82564C8.82564 5.00781 9.142 5.01721 9.12867 5.23509V5.68963C9.12867 5.68963 8.99049 6.44577 9.20443 7.12902V7.65933C9.20443 7.65933 9.25852 8.35198 9.05291 8.49266Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05344 8.49219H8.82617V9.02249H9.05344V8.49219Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97712 8.94531H8.90137V9.47562H8.97712V8.94531Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8556 8.2661H11.6284C11.445 8.02558 11.3393 7.73489 11.3253 7.43277V6.8267C11.3253 6.8267 11.4361 6.55473 11.3253 5.91761L11.1738 5.46307V5.00852C11.1738 5.00852 11.198 4.79064 11.4011 4.78125H11.6284C11.6284 4.78125 11.9447 4.79064 11.9314 5.00852V5.46307C11.9314 5.46307 11.7932 6.2192 12.0072 6.90246V7.43277C12.0072 7.43277 12.0613 8.12542 11.8556 8.2661Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8562 8.26562H11.6289V8.79593H11.8562V8.26562Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7799 8.71875H11.7041V9.24905H11.7799V8.71875Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3408 7.81278H10.1135C10.0131 7.5932 9.95597 7.35629 9.94533 7.11506V6.64233C9.94533 6.64233 10.0317 6.43021 9.94533 5.93324L9.82715 5.57869V5.22415C9.83151 5.17861 9.85159 5.13601 9.88394 5.10367C9.91629 5.07132 9.95888 5.05124 10.0044 5.04688H10.1817C10.1817 5.04688 10.4284 5.05445 10.4181 5.22415V5.57869C10.4181 5.57869 10.3105 6.16824 10.4771 6.70142V7.11521C10.4771 7.11521 10.5012 7.70301 10.3408 7.81278Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1133 7.8125H10.3406V8.19129H10.1133V7.8125Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3004 8.12109H10.2412V8.53306H10.3004V8.12109Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5982 6.59981L14.3558 6.29678V5.31193C14.3558 5.31193 14.5332 2.58973 11.174 2.73617H8.37093L7.31032 2.81193C7.31032 2.81193 5.14615 2.80185 5.18911 4.55435L5.71941 15.3119C5.71941 15.3119 5.84312 17.3927 7.68911 17.2816C7.68911 17.2816 11.0401 17.3775 13.4467 16.3725C13.4467 16.3725 14.7219 15.8321 14.7346 14.4028L14.6588 11.2968C14.6588 11.2968 14.6916 10.0291 13.4467 10.5392L11.9315 11.0695L11.78 11.9028C11.78 11.9028 12.4795 11.4987 12.8406 11.4483C12.8406 11.4483 13.9795 11.226 13.9012 12.1301C13.9012 12.1301 14.059 13.2917 13.2952 13.721C13.2952 13.721 12.4302 14.4407 10.4164 14.6301C10.4164 14.6301 10.448 14.226 10.1891 14.0241C10.1891 14.0241 10.1702 13.3422 10.9467 13.1907V12.3574C10.9467 12.3574 9.80403 12.2437 10.2649 11.0695L9.6588 10.5392L9.35577 10.7665C9.35577 10.7665 8.86964 10.9432 8.67396 10.615L8.44668 10.0089H7.61335C7.61335 10.0089 7.56918 10.7412 7.08305 10.7665C6.9478 10.7885 6.80932 10.7795 6.67807 10.7401C6.54682 10.7008 6.42624 10.6321 6.32547 10.5392L6.0982 5.0089C6.0982 5.0089 6.04138 3.82201 7.61335 3.79678H11.5527C11.5527 3.79678 13.352 3.64526 13.5224 5.31193L13.5982 6.59981Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14418 14.0227C8.77177 14.0227 9.28054 13.514 9.28054 12.8864C9.28054 12.2588 8.77177 11.75 8.14418 11.75C7.51658 11.75 7.00781 12.2588 7.00781 12.8864C7.00781 13.514 7.51658 14.0227 8.14418 14.0227Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6432 16.2766C10.9256 16.2766 11.1546 16.0477 11.1546 15.7653C11.1546 15.4829 10.9256 15.2539 10.6432 15.2539C10.3608 15.2539 10.1318 15.4829 10.1318 15.7653C10.1318 16.0477 10.3608 16.2766 10.6432 16.2766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9088 3.18945H8.78759C8.72483 3.18945 8.67395 3.24033 8.67395 3.30309C8.67395 3.36585 8.72483 3.41673 8.78759 3.41673H10.9088C10.9716 3.41673 11.0224 3.36585 11.0224 3.30309C11.0224 3.24033 10.9716 3.18945 10.9088 3.18945Z",
    fill: "#FF6F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5477_3131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.84848,
    height: 15,
    fill: "white",
    transform: "translate(5 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrexo);
export default __webpack_public_path__ + "static/media/prexo.0c1f36b47389ec547e85d719eb48f8f0.svg";
export { ForwardRef as ReactComponent };